/*
 * File: ui-label.ts
 * File Created: 2023-12-18 11:45:26
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-11-18 06:52:12
 * Modified By: Val Liu
 * -----
 */

import {
    BaseUITag,
    EUITagRuleType,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    IUITagMoreTagsUnit,
    UITag,
    EUITagRuleUnion,
} from "./core";
import Vue from "vue";

const DEFAULT_CELL_TYPE = "iv-cell-any";
const DEFAULT_FORM_TYPE = "iv-form-any";

// @uiType - add `element :is` to element.

@UITag.set({
    default: true,
})
export class uiType extends BaseUITag {
    appliedTo: EUITagTarget[] = [
        /// apply :is
        EUITagTarget.TableBodyCell,
        EUITagTarget.FormElement,

        /// apply specials
        EUITagTarget.TableHeaderCellContainer,
        EUITagTarget.TableBodyCellContainer,
        EUITagTarget.TableHeaderCell,
        EUITagTarget.TableSearch,

        /// handle submit
        EUITagTarget.FormSubmit,
    ];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.String];
    allowNullRule: boolean = false;

    /// set props :is
    parse(input: IUITagInput): IUITagResult | null {
        let rule = this.parseRule(input) as string;
        const target = input.target;

        /// set to default type
        if (input.isDefault === true) {
            if (target === EUITagTarget.FormElement) {
                /// form
                const typename = input.meta.attr.type.name;
                switch (typename) {
                    case "Date":
                        rule = "iv-form-datetime";
                        break;
                    case "number":
                        rule = "iv-form-number";
                        break;
                    case "boolean":
                        rule = "iv-form-switch";
                        break;
                    case "string":
                        rule = "iv-form-string";
                        break;
                    default:
                        rule = DEFAULT_FORM_TYPE;
                }
            } else {
                /// table
                const typename = input.meta.attr.type.name;
                switch (typename) {
                    case "Date":
                        rule = "iv-cell-datetime";
                        break;
                    case "boolean":
                        rule = "iv-cell-switch";
                        break;
                    case "number":
                        rule = "iv-cell-number";
                        break;
                    case "string":
                        rule = "iv-cell-string";
                        break;
                    default:
                        rule = DEFAULT_CELL_TYPE;
                }
            }
        } else if (rule == null) {
            return null;
        }

        /// if EUITagTarget.TableBodyCell | FormElement, set the props
        let props: IUITagResult["props"] = undefined;
        if (
            target === EUITagTarget.TableBodyCell ||
            target === EUITagTarget.FormElement
        ) {
            props = { is: rule };
        }

        return {
            props,
            /// load the rule type, set the specials.moreTags
            specials: {
                moreTags: getMoreTagsFromType(rule),
            },
        };
    }
}

export function getMoreTagsFromType(type: string): IUITagMoreTagsUnit[] {
    const rtn: IUITagMoreTagsUnit[] = [];

    /// load the rule type, set the specials.moreTags
    const components = (Vue as any).options.components;
    const component = components[type as any];
    if (component != null) {
        const name = component.name;
        const meta = UITag.getDefault(name as string);
        if (meta != null) {
            const metax = meta.meta;
            return Object.keys(metax).reduce<IUITagMoreTagsUnit[]>((final, tag) => {
                final.push({
                    tag,
                    rule: metax[tag],
                });
                return final;
            }, []);
        }
    }

    return rtn;
}
